import { render } from "./Asset_disposal_report.vue?vue&type=template&id=bd2c0d7e&scoped=true"
import script from "./Asset_disposal_report.vue?vue&type=script&lang=js"
export * from "./Asset_disposal_report.vue?vue&type=script&lang=js"

import "./Asset_disposal_report.vue?vue&type=style&index=0&id=bd2c0d7e&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2c0d7e"]])

export default __exports__